import React from 'react';
import { SnackbarProps, IconButton } from '@mui/material';
import { StyledSnackbar } from './styles';
import { GivelifyIcon } from '../components/GivelifyIcon';

export interface GivelifySnackbarProps extends SnackbarProps {
    hasCloseButton?: boolean;
}

export function GivelifySnackbar({
    open,
    onClose,
    className,
    anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'center',
    },
    autoHideDuration = 3000,
    hasCloseButton = false,
    ...rest
}: GivelifySnackbarProps) {
    const handleCloseClick = (event: React.SyntheticEvent<any>) => {
        if (onClose) onClose(event, 'timeout');
    };

    return (
        <StyledSnackbar
            anchorOrigin={anchorOrigin}
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            className={className}
            data-testid="givelify-snackbar"
            action={
                hasCloseButton ? (
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseClick}
                    >
                        <GivelifyIcon
                            variant="close"
                            size="13px"
                            color="inherit"
                        />
                    </IconButton>
                ) : null
            }
            {...rest}
        />
    );
}
